import { useStore } from '@tanstack/react-store';
import React from 'react';
import { ticketData as data } from '~/data/tickets';
import { langStore } from '~/store/langStore';
import CommunityTickets from './CommunityTickets';
import EarlyBirdTicket from './EarlyBirdTickets';

export function OnlineTickets() {
  const locale = useStore(langStore, s => s);

  return (
    <>
      <div>
        <EarlyBirdTicket
          position={data.position[locale]}
          link={locale === 'RS' ? data.links.gigstixLink : data.links.tixaLink}
          priceHuf="20 000"
          priceEur="42"
          priceRsd="5 000"
          text={data.buy[locale]}
          pricepos="56.148"
        />
      </div>
      <div>
        <CommunityTickets
          position={data.position[locale]}
          link={locale === 'RS' ? data.links.gigstixLink : data.links.tixaLink}
          priceHuf="40 000"
          priceEur="100"
          priceRsd="12 000"
          text={data.buy[locale]}
          pricepos="65.191"
        />
      </div>
    </>
  );
}

const Tickets: React.FC = () => {
  return (
    <div className="text-center">
      {/* <h2 className="text-4xl font-bold text-beige2 mb-12">{data.tickets[locale]}</h2> */}
      <div className="flex flex-wrap justify-center gap-8">
        <OnlineTickets />
      </div>
    </div>
  );
};

export default Tickets;
